/**
 * @desc Number of clients to show in the preview cards before the modal enables
 */
export const CLIENTS_TO_PREVIEW = 2;
